<template>
    <section class="faq-section">
        <div >
            <h2 class="section-title text-center text-lg">{{ $t('welcome.faq.title') }}</h2>
            <p class="section-subtitle text-center  text-md">{{ $t('welcome.faq.subtitle') }}</p>

            <div class="faq-list">
                <div
                    v-for="(faq, index) in faqs"
                    :key="index"
                    :class="{ active: activeIndex === index }"
                    class="faq-item"
                >
                    <button
                        class="faq-question"
                        @click="toggleFaq(index)"
                    >
                        <span>{{ $t(`welcome.faq.items.${faq.id}.question`) }}</span>
                        <font-awesome-icon
                            :icon="activeIndex === index ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
                            class="faq-icon"
                        />
                    </button>
                    <div v-show="activeIndex === index" class="faq-answer">
                        <p>{{ $t(`welcome.faq.items.${faq.id}.answer`) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import {ref} from 'vue';

const activeIndex = ref(null);

const faqs = ref([
    {id: 0},
    {id: 2},
    {id: 3},
    {id: 4},
    {id: 7},
    {id: 8},
    {id: 9},
    {id: 10},
]);

const toggleFaq = (index) => {
    activeIndex.value = activeIndex.value === index ? null : index;
};
</script>

<style scoped>
.faq-section {
    padding: 80px 0;
    background: white;
    text-align: center;
}

.faq-section .section-title {
    font-size: 48px;
    font-weight: 800;
    margin: 0 0 16px 0;
    color: #1e293b;
}

.faq-section .section-subtitle {
    font-size: 20px;
    color: #64748b;
    margin: 0 auto 30px auto;
    max-width: 700px;
}

.faq-list {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 10px;
}

.faq-item {
    background: white;
    border: 2px solid #f1f5f9;
    border-radius: 12px;
    margin-bottom: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-item:hover {
    border-color: #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.faq-item.active {
    border-color: #0ea5e9;
    box-shadow: 0 4px 16px rgba(14, 165, 233, 0.15);
}

.faq-question {
    width: 100%;
    padding: 24px 28px;
    background: transparent;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    text-align: left;
    transition: all 0.3s ease;
}

.faq-question:hover {
    color: #0ea5e9;
}

.faq-item.active .faq-question {
    color: #0ea5e9;
}

.faq-icon {
    color: #64748b;
    font-size: 16px;
    transition: all 0.3s ease;
    flex-shrink: 0;
    margin-left: 20px;
}

.faq-item.active .faq-icon {
    color: #0ea5e9;
}

.faq-answer {
    padding: 0 28px 24px 28px;
    color: #475569;
    font-size: 16px;
    line-height: 1.7;
    animation: slideDown 0.3s ease;
}

.faq-answer p {
    margin: 0;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .faq-question {
        font-size: 16px;
        padding: 20px 20px;
    }

    .faq-answer {
        padding: 0 20px 20px 20px;
        font-size: 15px;
    }
}
</style>
